module.exports = __webpack_public_path__ + "ca3dda86bb2a7d2833502911f5740392.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/jg-logo-light.svg
// module id = 905
// module chunks = 0